module.exports = __webpack_public_path__ + "img/Driver_Sm.888ed1e4.svg";